// Pure helpers for out-of-stock menu rendering.
// An item is "available" unless the backend explicitly set visible === false.
// Menus that pre-date the backend field have no `visible`, so undefined/true
// both count as available (backward-compatible).

const isAvailable = (item) => item?.visible !== false;

export const getVisibleItems = (items) =>
  (Array.isArray(items) ? items : []).filter(isAvailable);

export const areAllItemsSoldOut = (items) => {
  const list = Array.isArray(items) ? items : [];
  if (list.length === 0) return false;
  return list.every((item) => item?.visible === false);
};

// Visible items, or all items when none are visible (so a fully sold-out
// product still has a row list and a "from" price to display).
export const getDisplayItems = (items) => {
  const visible = getVisibleItems(items);
  if (visible.length > 0) return visible;
  return Array.isArray(items) ? items : [];
};

export const getDisplayPrice = (items) => {
  const list = getDisplayItems(items);
  if (list.length === 0) return 0;
  return list.reduce(
    (min, item) => (item.price < min ? item.price : min),
    list[0].price,
  );
};
